import { defineStore } from 'pinia'
export const useFavoritesStore = defineStore('favoritesStore', {
    state: () => ({
        selected: {
            offers: {
                items: [],
                objects: [],
                total: null,
                count: null
            },
            builds: {
                items: [],
                objects: [],
                total: null,
                count: null
            }
        },
    }),
    actions: {

        init(){
            if( import.meta.client ){

                this.selected.offers.items = [];
                this.selected.builds.items = [];

                if( !localStorage.getItem('favorites') ) localStorage.setItem('favorites', '[]')
                var list = localStorage.getItem('favorites')
                var items = JSON.parse( list )

                var offers = items.filter( e => e.type == 'offers' )
                var builds = items.filter( e => e.type == 'builds' )

                offers.map( e => this.selected.offers.items.push( e.id ) )
                builds.map( e => this.selected.builds.items.push( e.id ) )

                this.meta()

            }
        },
        
        async getList(){
                
            let offers = []
            let builds = []

            this.selected.offers.items.map( i => {
                offers.push( i )
            })

            this.selected.builds.items.map( i => {
                builds.push( i )
            })

            const { data } = await useFetch(`${useRequestURL().origin}/api/realty/favorites`, {
                method: "POST",
                headers: {
                    'Content-Type': "application/json"
                },
                body: JSON.stringify({ offers, builds }),
                redirect: "follow"
            });

            // Я не знаю почему но эта конченая тварь без setTimeout не работает
            setTimeout(() => {
                const { status, response } = data.value
                if( status == 'success' ){
                    this.selected.offers.objects = response.offers
                    this.selected.builds.objects = response.builds
                }
            }, 500);
            
        },

        ls_update(){
            var list = []

            var offers = this?.selected?.offers?.items.map( item_id => {
                return {
                    type: 'offers',
                    id: item_id
                }
            })
            list = list.concat( offers )

            var builds = this?.selected?.builds?.items.map( item_id => {
                return {
                    type: 'builds',
                    id: item_id
                }
            })
            list = list.concat( builds )

            // console.log( 'items', list.length, list )
            var items = JSON.stringify( list )
            // console.log('items', items)
            localStorage.setItem('favorites', items)

        },

        meta(){
            this.selected.offers.count = this?.selected?.offers?.items?.length
            this.selected.builds.count = this?.selected?.builds?.items?.length
        },

        add( id, type = 'offers' ){
            // console.log('favorites add', id, type );
            if( !this.selected[type].items.find( number => number == id ) ) this.selected[type].items.push( id )
            this.ls_update()
            this.meta()
        },

        remove( id, type = 'offers' ){
            // console.log('favorites remove', id, type );
            if( this.selected[type].items.find( number => number == id ) ) this.selected[type].items = this.selected[type].items.filter( number => number != id )
            this.ls_update()
            this.meta()
        },

        is( id, type = 'offers' ){
            return ( this.selected[type].items.find( number => number == id ) ) ? true : false
        },

        toggle( id, type = 'offers' ){
            // console.log( 'toggle',  );
            var status = this.is( id, type )
            if( status ){
                this.remove( id, type )
            }
            if( !status ){
                this.add( id, type )
            }
            this.ls_update()
            this.meta()
        },

        values( type = 'offers' ){
            return this.selected[type].items
        },

        empty( type = 'offers' ){
            this.selected[type].items = []
            this.ls_update()
            this.meta()
        },

    }
})